<template>
  <div class="commonTitle c-152338">
    <div class="titleContent" :class="{'noBorder': noBorder}">
      <div v-if="isShowBack" @click="goBack()" class="backLayout">
        <van-icon name="arrow-left" color="#152338" />
      </div>
      <div class="titleText line-1">
        <slot name="titleText"></slot>
      </div>
      <slot name="rightText"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'commonTitle',
    props: {
      isShowBack: {
        type: Boolean,
        default: true
      },
      customGoBack: {
        type: Boolean,
        default: false
      },
      noBorder: { // 没有下边框
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {
      goBack() {
        if (this.customGoBack) {
          this.$emit("goBack");
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
</script>script>
</script>

<style lang="scss" scoped>
  .commonTitle {
    width: 100%;
    height: 4.8rem;
    position: relative;

    .titleContent {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: white;
      border-bottom: 1px solid #e6edf5;
      z-index: 10;

      &.noBorder {
        border-bottom-color: transparent;
      }

      .backLayout {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1.5rem 0 0.8rem;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 2rem;
      }

      .titleText {
        position: absolute;
        left: 4.8rem;
        top: 0;
        width: calc(100% - 4.8rem * 2);
        height: 100%;
        line-height: 4.8rem;
        font-size: 1.6rem;
        text-align: center;
      }

      .rightText {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1.5rem;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 1.6rem;
        color: #6ecc80;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/commonTitle.vue